import './whitetablecatering/style';
import FormStructure from './whitetablecatering/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js